import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Slots } from '@classes/slots/slots';
import { faInfoCircle, faSearch, faSyncAlt, faChevronLeft, faPen, faVideo, faEye } from '@fortawesome/free-solid-svg-icons';
import { DataService } from '@services/data/data.service';
import { SlotsService } from '@services/slots/slots.service';
import { DashbordService } from '@services/dashboard/dashbord.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { OpendialogOverviewParkComponent } from '../smartparking-dialog/opendialog-overview-park/opendialog-overview-park.component';

interface Time {
  day: number; hour: number; min: number; sec: number;
}

@Component({
  selector: 'app-smartparking-slots',
  templateUrl: './smartparking-slots.component.html',
  styleUrls: ['./smartparking-slots.component.scss']
})
export class SmartparkingSlotsComponent extends SubscriptionBaseComponent implements OnInit {

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faSyncAlt = faSyncAlt;
  faChevronLeft = faChevronLeft;
  faPen = faPen;
  faVideo = faVideo;
  faEye = faEye;

  show = false;

  idCamera: string;
  nameCamera: string;
  placeFree: number;
  placeOccupied: number;
  numbCarsTimeLimitExceeded: number;
  carsTimeLimitExceeded: Slots[];


  displayedColumnsAdmin: string[] = ['name', 'status', 'statusTime', 'timeLimitExceeded'];
  displayedColumns: string[] = ['name', 'status'];
  dataSource: MatTableDataSource<Slots>;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  loading = false;
  isAdmin: boolean;
  parking: Slots[];

  today = new Date();


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  numberOfCarSuctionCup: number;


  constructor(
    private route: ActivatedRoute,
    private slotsService: SlotsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dashboardService: DashbordService,
    private router: Router,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.getQueryParams();
    this.getSuctionCupCarToday();
  }

  applyFilter(filterValue): void {
    this.slotsService.keyword.next(filterValue);
  }

  refreshInfoParking(): void {
    this.loading = true;
    this.getPlaceParking();
  }

  showElement(): void {
    this.show = true;
  }

  getNameSlot(name: string): string {
    const newName = name.slice(4, (name.length));

    return newName;
  }

  getImgParking(): string {
    return `${this.route.snapshot.queryParams.ip}/snapshot`;
  }

  openDialogPreviewParking(): void {
    const dialogReg = this.dialog.open(OpendialogOverviewParkComponent, { data: { imgParking: `${this.route.snapshot.queryParams.ip}/snapshot` } });
  }

  getSuctionCupCarToday(): void {
    const cameraId = this.route.snapshot.queryParams.id;

    this.dashboardService.getInfosCarSuctionToday(cameraId).subscribe({
      next: numberOfCarSuctionCup => this.numberOfCarSuctionCup = numberOfCarSuctionCup
    });
  }

  timeIsExceeded(date: string, status: string): string {
    const hour = parseInt(date?.split('T')[1]?.split(':')[0], 10);
    const dateStart = new Date(date);
    dateStart.setHours(hour);
    const today = new Date();

    const tE: Time = this.countDiffTime(dateStart, today);

    if (status === 'Free') {
      return 'Free';
    }
    else if (status === 'Occupied' && ((tE.hour === 1 && tE.min < 30) || (tE.hour === 0 && tE.min < 60))) {
      return 'Occupied';
    } else if (status === 'Occupied' && (tE.hour === 1 && tE.min >= 30) || (tE.hour > 1)) {
      return 'timeExceeded';
    }

  }

  goToUrl(event): void {
    // const strWindowFeatures = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
    window.open(event.target.dataset.href, '_blank');
    // window.open(event.target.dataset.href, '_blank');
  }

  private countDiffTime(date1, date2) {
    const diff: Time = {
      day: null,
      hour: null,
      min: null,
      sec: null
    };

    // Initialisation du retour
    let tmp = date2 - date1;

    tmp = Math.floor(tmp / 1000);             // Nombre de secondes entre les 2 dates
    diff.sec = tmp % 60;                    // Extraction du nombre de secondes

    tmp = Math.floor((tmp - diff.sec) / 60);    // Nombre de minutes (partie entière)
    diff.min = tmp % 60;                    // Extraction du nombre de minutes

    tmp = Math.floor((tmp - diff.min) / 60);    // Nombre d'heures (entières)
    diff.hour = tmp % 24;                   // Extraction du nombre d'heures

    tmp = Math.floor((tmp - diff.hour) / 24);   // Nombre de jours restants
    diff.day = tmp;

    return diff;
  }

  private getQueryParams(): void {
    this.idCamera = this.route.snapshot.queryParams.id;
    this.nameCamera = this.route.snapshot.queryParams.name;
    this.getPlaceParking();
  }

  private getPlaceParking(): void {
    this.slotsService.getParkingPlaceByCamera(this.idCamera).subscribe(res => {
      this.parking = res;

      this.placeFree = 0;
      this.placeOccupied = 0;
      this.numbCarsTimeLimitExceeded = 0;
      this.carsTimeLimitExceeded = [];

      res?.forEach(slot => {
        slot.status === 'Occupied' ?
          this.placeOccupied++ :
          this.placeFree++;

        if (slot.timeLimitExceeded === true) {
          this.numbCarsTimeLimitExceeded++;
          this.carsTimeLimitExceeded.push(slot);
        }
      });
      setTimeout(() => {
        this.loading = false;

      }, 1000);

    });
  }

  private initSub() {
    this.subscription.add(
      this.dataService.isAdmin.asObservable().subscribe(isAdmin => {
        this.isAdmin = isAdmin;
        this.cdr.detectChanges();
      })
    );
  }

}
